import gql from 'graphql-tag';

export const GET_LINE_ITEMS_IDS = gql`
  query GET_LINE_ITEMS_IDS($ids: [ID!]!, $limit: Int!) {
    lineItems: lineItemsV5(
      filterOptions: { campaignIdList: $ids, skipCPEligibilityCalculation: true }
      paginationOptions: { limit: $limit }
    ) {
      edges {
        node {
          id
          # Caches each line item's parent campaign, so the cascade can resolve ancestors from the
          # Apollo cache instead of fetching. Batched upstream, so it costs no extra call.
          campaign {
            id
          }
        }
      }
    }
  }
`;
